import { postProjectChatMessage } from '../api/chatCompletion';
import { postChatbotSse } from '../api/postChatbotSse';
import { sendChatbotWsTurn as sendChatbotWsTurnImpl } from '../ws/sendChatbotWsTurn';

/**
 * Transport facade: dummy/REST project messages via {@link postProjectChatMessage};
 * SSE chatbot via {@link postChatbotSse} (see `isChatbotSseEnabled` in config);
 * WebSocket chatbot via {@link sendChatbotWsTurn} (see `isChatbotWebSocketEnabled` in config).
 *
 * @param {{
 *   projectId: string,
 *   messages: Array<{ role: string, content: string }>,
 *   modulePath: string,
 * }} params
 * @returns {Promise<string>}
 */
export function sendChatMessage(params) {
  return postProjectChatMessage(params);
}

/**
 * @param {{
 *   message: string,
 *   conversationId?: string,
 *   settings: object,
 *   onTextDelta?: (chunk: string) => void,
 *   onConversationId?: (id: string) => void,
 * }} params
 * @returns {Promise<{ assistantText: string, conversationId: string }>}
 */
export function sendChatbotSseTurn(params) {
  return postChatbotSse(params);
}

/**
 * @param {import('../ws/chatbotWebSocketSession').ChatbotWebSocketSession} session
 * @param {{
 *   message: string,
 *   conversationId?: string,
 *   settings: object,
 *   onTextDelta?: (chunk: string) => void,
 *   onConversationId?: (id: string) => void,
 * }} params
 * @returns {Promise<{ assistantText: string, conversationId: string }>}
 */
export function sendChatbotWsTurn(session, params) {
  return sendChatbotWsTurnImpl(session, params);
}
